module.exports = __webpack_public_path__ + "img/218.8190332b.png";